import classNames from 'classnames'
import { FunctionComponent, ReactNode } from 'react'
import orderSummaryStyles from '@/app/_components/OrderSummary/OrderSummary.module.css'
import styles from './DateTimeHeader.module.css'
import { AdmissionType, AdmissionTypeValues } from '@/types/general.types'
import TXT from '@/messages'
import { formatTimeToAMPM } from '@/utils/dates.utils'
import { GLOBAL_CLASSES } from '@/config/html-attributes.config'

type Props = {
  admissionType: AdmissionTypeValues
  date: string
  entryTime: string | null
  endTime: string | null
  displayMembership: boolean
  timezone: string
}

const DateTimeHeader: FunctionComponent<Props> = ({
  admissionType,
  date,
  entryTime,
  endTime,
  displayMembership,
  timezone,
}: Props) => {
  const isDayPass = admissionType === AdmissionType.DayPass
  let timeText: string | ReactNode = TXT.orderSummary.dateTimeEmpty
  const timeHeader = isDayPass
    ? TXT.dateTimeHeader.exhibitHours
    : TXT.dateTimeHeader.entryTime

  if (entryTime) {
    const formattedEntryTime = formatTimeToAMPM(entryTime, timezone)
    if (!isDayPass) {
      timeText = formattedEntryTime || TXT.orderSummary.dateTimeEmpty
    } else if (endTime) {
      const formattedEndTime = formatTimeToAMPM(endTime, timezone)
      timeText = (
        <>
          <span>{formattedEntryTime}</span>
          {' - '}
          <span>{formattedEndTime}</span>
        </>
      )
    }
  }
  return (
    <div className={classNames(styles.Row, { [styles.DisplayMembership]: displayMembership })}>
      <div className={styles.Column}>
        <h2 className={classNames(
          orderSummaryStyles.GeneralTitle,
          orderSummaryStyles.MinorTitle,
          styles.ReservationHeader,
        )}
        >
          {TXT.dateTimeHeader.date}
        </h2>
        <div data-testid="order-summary-date" className={styles.ReservationValue}>
          {date}
        </div>
      </div>
      <div className={styles.Column}>
        <h2 className={classNames(
          orderSummaryStyles.GeneralTitle,
          orderSummaryStyles.MinorTitle,
          styles.ReservationHeader,
        )}
        >
          {timeHeader}
        </h2>
        <div
          data-testid="order-summary-time"
          className={classNames(styles.ReservationValue, styles.TimeText, GLOBAL_CLASSES.TypoStandard)}
        >
          {timeText}
        </div>
      </div>
    </div>
  )
}

export default DateTimeHeader
